<template>
  <video ref="video" v-bind="$attrs">
    <slot></slot>
  </video>
</template>

<script>
export default {
  name: 'AppVideo',
  props: {
    isPlaying: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isPlaying: 'onIsPlayingChange'
  },
  async mounted() {
    await this.onIsPlayingChange();
  },
  methods: {
    async onIsPlayingChange() {
      if (this.isPlaying) {
        try {
          await this.$refs.video.play();
        } catch (error) {
          const errorMessage = `${error}`;

          if (errorMessage.includes("user didn't interact with the document first")) {
            return;
          }

          throw error;
        }
      } else {
        this.$refs.video.pause();
      }
    }
  }
};
</script>
